export default __webpack_public_path__ + "static/media/appointment-booking.c1053951.png";